import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React, { useRef } from 'react';

import { DirectoriesTable } from 'components/DirectoriesTable';
import { HideStationSelector } from 'layouts/HideStationSelector';

export function Directories() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <HideStationSelector>
      <TablePageLayout
        title="Map instellingen"
        actionContent={
          <Button
            sx={{ ml: 5 }}
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              tableRef.current?.openFormDialog();
            }}
          >
            Map toevoegen
          </Button>
        }
      >
        <DirectoriesTable
          id="directories-table"
          ref={tableRef}
          searchFilter={{
            inputProps: {
              placeholder: 'Zoeken op naam',
            },
            filter: (search) => ({
              _or: search.flatMap((str) => [{ name: { _ilike: `%${str}%` } }]),
            }),
          }}
        />
      </TablePageLayout>
    </HideStationSelector>
  );
}
